/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:06:22
 * @Explain: 联系人管理
 */

export default {
  // 渠道类型
  'CONTACT.MANAGE.CHANNEL.TYPE.EMAIL': '邮箱',
  'CONTACT.MANAGE.CHANNEL.TYPE.WHATSAPP': 'WhatsApp',
  'CONTACT.MANAGE.CHANNEL.TYPE.DISCORD': 'Discord',
  'CONTACT.MANAGE.CHANNEL.TYPE.STEAM': 'Steam',
  // 用户来源
  'CONTACT.SOURCE.LI-PASS': 'LIPass - SDK',
  'CONTACT.SOURCE.IN-GAME': 'Databrain',
  'CONTACT.SOURCE.FILE': 'CSV',
  'CONTACT.SOURCE.SINGLE-ADD': '单独添加',
  'CONTACT.SOURCE.TOOLS': '工具 - 后台更新',
  'CONTACT.SOURCE.DATA-SCIENCE-TEAM': 'Data Science Team',
  'CONTACT.SOURCE.NEWSLETTER-SIGN-UP': 'LIPass - WEB',
  'CONTACT.SOURCE.SIGN-UP-FORM': '表单',
  'CONTACT.SOURCE.ASSOCIATE_GROUP': '',
  'CONTACT.SOURCE.WHATSAPP': 'WhatsApp',
  'CONTACT.SOURCE.DETAILS': '联系人详情页',
  'CONTACT.SOURCE.OPTIN': '二次确认',
  'CONTACT.SOURCE.JOURNEY': '旅程',
  'CONTACT.SOURCE.RECRUIT': '官网招募',

  // 联系人列表
  'CONTACT.LIST.PROFILE': '头像',

  // 联系人详情
  'CONTACT.DETAILS.CHANNEL.ID': 'ID',
  'CONTACT.DETAILS.CHANNEL.USERNAMEA': '{channelName} 用户名',
  'CONTACT.DETAILS.CHANNEL.ACCOUNT.CREATED': '创建于',
  'CONTACT.DETAILS.KRY': 'Steam key',
  'CONTACT.DETAILS.WISHLIST.LABEL': 'Steam愿望清单',
  'CONTACT.DETAILS.WISHLIST.STATUS': '是否加入愿望清单',
  'CONTACT.DETAILS.PRIVATE.VALUE': '未公开',
  'CONTACT.DETAILS.UNKNOWN.VALUE': '未知',
  'CONTACT.DETAILS.PLAYTIME.LABEL': '游戏时长',
  'CONTACT.DETAILS.PLAYTIME.PUBLIC.HOURS.VALUE': '{hours}时',
  'CONTACT.DETAILS.PLAYTIME.PUBLIC.MINS.VALUE': '{minutes}分',
  'CONTACT.DETAILS.WISHLIST.VALUE.1': '已添加',
  'CONTACT.DETAILS.WISHLIST.VALUE.2': '未添加',
  'CONTACT.DETAILS.NIGHT.MARKETING.LABEL': '是否允许夜间营销',
  'CONTACT.DETAILS.NIGHT.MARKETING.VALUE.1': '允许',
  'CONTACT.DETAILS.NIGHT.MARKETING.VALUE.2': '不允许',
  'CONTACT.DETAILS.NIGHT.MARKETING.VALUE.3': '未知',
  'CONTACT.DETAILS.NIGHT.MARKETING.BUBBLE':
    '韩国法律规定，若在晚上9点至次日上午8点之间，发送营利目的广告性信息。发送者必须获得接收者的单独事先同意。<br/>若用户不允许或未知用户是否允许，则在活动发送时会跳过夜间时段。',

  // 用户 - 管理用户
  // 'CONTACT.MANAGE.LIST.TITLE': '所有联系人管理',
  'CONTACT.MANAGE.FILTER.ALL': '包含全部',
  'CONTACT.MANAGE.FILTER.ANY': '包含任何一个',
  'CONTACT.MANAGE.FILTER.TAG.ALL.TIP':
    '系统内联系人标签，具备此处选择的全部标签',
  'CONTACT.MANAGE.FILTER.TAG.ANY.TIP':
    '系统内联系人的标签，具备此处选择的任意一个标签即可',
  'CONTACT.MANAGE.FILTER.SOURCE.ALL.TIP':
    '系统内联系人来源，具备此处选择的全部来源',
  'CONTACT.MANAGE.FILTER.SOURCE.ANY.TIP':
    '系统内联系人的来源，具备此处选择的任意一个来源即可',
  'CONTACT.MANAGE.LIST.EMAIL.ADDRESS': '邮箱',
  'CONTACT.MANAGE.LIST.CONTACTS.ADDRESS': '联系方式',
  'CONTACT.MANAGE.LIST.LAST.CHANGE': '上次修改',
  'CONTACT.MANAGE.LIST.MAIL.ADDRESS': '邮件地址',
  'CONTACT.MANAGE.LIST.SEARCH.MAIL.ADDRESS': '请输入邮件地址',
  'CONTACT.MANAGE.LIST.SEARCH.MAIL.WHATSAPP.ADDRESS':
    '请输入邮件地址/WhatsApp号码',
  'CONTACT.MANAGE.LIST.SUBSCRIPTION.STATUS': '订阅状态',
  'CONTACT.MANAGE.LIST.PREFERENCE': '偏好',
  'CONTACT.MANAGE.LIST.ENGAGEMENT.RATING': '参与度',
  'CONTACT.MANAGE.LIST.HIGH': '高',
  'CONTACT.MANAGE.LIST.MEDIUM': '中',
  'CONTACT.MANAGE.LIST.LOW': '低',
  'CONTACT.MANAGE.LIST.EDITOR': '编辑人',
  'CONTACT.MANAGE.ADD.DATE': '添加日期',
  'CONTACT.MANAGE.LIST.LAST.SAVED': '上次保存时间',
  'CONTACT.MANAGE.LIST.SUBSCRIBED': '已订阅',
  'CONTACT.MANAGE.LIST.UNSUBSCRIBED': '未订阅',
  'CONTACT.MANAGE.LIST.PENDING': '待定',
  'CONTACT.MANAGE.LIST.UNBOUND': '未绑定',
  'CONTACT.MANAGE.LIST.EXPORT.SEGMENT': '导出分层',
  'CONTACT.MANAGE.LIST.CREATE.CONTACT': '新增联系人',
  'CONTACT.MANAGE.LIST.CREATE.CONTACT.TIPS':
    '暂不可用，仅支持线下通过API传入联系人',
  'CONTACT.MANAGE.LIST.ADV.TIPS':
    '将LEVEL INFINITE PASS中的实时数据同步到SmartLink中，自动为您提供准确、有序和信息丰富的见解。',
  'CONTACT.MANAGE.LIST.GO.TO.SETTINGS': '去设置',
  'CONTACT.MANAGE.LIST.SEGMENT.SEND.CAMPAIGN': '分层并发送活动',
  'CONTACT.MANAGE.LIST.TOTAL.TIPS':
    '共有 <b class="color-primary">{total}</b> 条，<b class="color-primary">{subscriberTotal}</b> 个订阅者',
  'CONTACT.MANAGE.LIST.QUICK.MODAL.TITLE': '创建分层并发送活动',
  'CONTACT.MANAGE.LIST.QUICK.MODAL.SAVE': '保存并发送活动',
  'CONTACT.MANAGE.LIST.SOURCE.LABEL.MAX.NUM.TIPS':
    '来源和标签选择条数超过{maxNum}条，请删减后重试',
  'CONTACT.MANAGE.LIST.RECORD': '导入历史',
  'CONTACT.MANAGE.LIST.IMPORT.HISTORY': '导入历史',
  'CONTACT.MANAGE.LIST.EXPORT.HISTORY': '导出中心',
  'CONTACT.MANAGE.LIST.DEL.HISTORY': '删除历史',
  'CONTACT.MANAGE.LIST.FIELD.SETTINGS': '用户属性',
  'CONTACT.MANAGE.LIST.OPT.IN.SETTINGS': '联系人加入设置',
  'CONTACT.MANAGE.LIST.EXIST.SEGMENT.TITLE': '你创建的规则已存在',
  'CONTACT.MANAGE.LIST.EXIST.SEGMENT.DESC':
    '确认后你可以在筛选中直接使用该规则',
  'CONTACT.MANAGE.LIST.EXIST.SEGMENT.DESC1':
    '确认后你可以在列表查找或使用该规则',
  'CONTACT.MANAGE.LIST.EXIST.SEGMENT.DESC2': '确认后你将返回到分层管理页',
  'CONTACT.MANAGE.LIST.TAGS': '标签',
  'CONTACT.MANAGE.LIST.SOURCE': '来源',
  'CONTACT.MANAGE.LIST.SEGMENT': '分层',
  'CONTACT.MANAGE.LIST.RESET': '重置',

  'CONTACT.MANAGE.LIST.ENGAGEMENT.RATING.DESC.TITLE':
    '参与度体现玩家活动的互动情况，参与度越高，玩家互动频率越高',

  'CONTACT.MANAGE.LIST.DROPDOWN.VISIBLE': '选择当前页',
  'CONTACT.MANAGE.LIST.DROPDOWN.ALL': '选择全部',
  'CONTACT.MANAGE.LIST.DROPDOWN.NONE': '取消选择全部',
  'CONTACT.MANAGE.LIST.DEL.TITLE': '确定批量删除联系人？',
  'CONTACT.MANAGE.LIST.DEL.DESC.1': '已选中 ',
  'CONTACT.MANAGE.LIST.DEL.DESC.2':
    ' 个联系人。删除后，所有选中联系人信息均被删除且不可恢复。',
  'CONTACT.MANAGE.LIST.DEL.CONFIRM': '删除',
  'CONTACT.MANAGE.LIST.DEL.LABEL': '输入 <b>删除</b> 已确认',
  'CONTACT.MANAGE.LIST.DEL.PROGRESS': '删除进度',
  'CONTACT.MANAGE.LIST.DEL.SUCCESS': '成功删除{num}联系人',
  'CONTACT.MANAGE.LIST.DEL.MAX': '一次最多可选择{num}个联系人信息',
  'CONTACT.MANAGE.LIST.EXPORT.TITLE': '导出属性设置',
  'CONTACT.MANAGE.LIST.EXPORT.DESC': '选择要导出的属性',
  'CONTACT.MANAGE.LIST.EXPORT.ATTRIBUTE.NAME': '属性名称',
  'CONTACT.MANAGE.LIST.EXPORT.ATTRIBUTE.TYPE': '属性类型',
  'CONTACT.MANAGE.LIST.EXPORT.SURE': '导出',
  'CONTACT.MANAGE.LIST.EXPORT.INFO':
    '导出过程将持续一段时间，完成后您将收到电子邮件通知。',
  'CONTACT.MANAGE.LIST.EXPORT.LIPASS.INFO':
    '导出过程将持续一段时间，完成后您将收到电子邮件通知。 注意：<span class="font-weight-700">仅仅</span>来自 <span class="font-weight-700">LEVEL INFINITE PASS</span> 的联系人<span class="font-weight-700">无法</span>导出',
  'CONTACT.MANAGE.LIST.DETAIL.CHANNELS': '渠道',
  'CONTACT.MANAGE.LIST.DETAIL.PROFILE': '用户档案',
  'CONTACT.MANAGE.LIST.DETAIL.CHANNELS.EMAIL': '邮箱',
  'CONTACT.MANAGE.LIST.DETAIL.CHANNELS.WHATSAPP': 'WhatsApp',
  // 老版本时间线
  'CONTACT.MANAGE.USER.DETAILS': '用户详情',
  'CONTACT.MANAGE.DETAIL.TIME.TITLE': '时间线',
  'CONTACT.MANAGE.TIME.LINE.TIPS.1-FILE':
    '<span class={calssNames}>{operatorOrsource}</span> 通过{source}上传新用户',
  'CONTACT.MANAGE.TIME.LINE.TIPS.1-SINGLE-ADD': '单独添加上传新用户',
  'CONTACT.MANAGE.TIME.LINE.TIPS.1-API':
    '通过 <span>{source}</span> 上传新用户',
  'CONTACT.MANAGE.TIME.LINE.TIPS.1-LI-PASS': '通过{source}上传新用户',
  'CONTACT.MANAGE.TIME.LINE.TIPS.2':
    '由 <span class={calssNames}>{operatorOrsource}</span> 新增来源',
  'CONTACT.MANAGE.TIME.LINE.TIPS.3-1':
    '由 <span class={calssNames}>{operatorOrsource}</span> 新增标签',
  'CONTACT.MANAGE.TIME.LINE.TIPS.3-2':
    '由 <span class={calssNames}>{operatorOrsource}</span> 新增<span class="time-line-variable">{name}</span>标签',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-1-1': '由玩家自己更新订阅状态为订阅',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-1-2':
    '<span class={calssNames}>{operatorOrsource}</span> 更新订阅状态为已订阅',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-2-1': '由玩家自己更新订阅状态为取消订阅',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-2-2':
    '<span class={calssNames}>{operatorOrsource}</span> 更新订阅状态为取消订阅',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-3-1': '由玩家自己更新订阅状态为未知',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-3-2':
    '<span class={calssNames}>{operatorOrsource}</span> 更新订阅状态为未知',
  'CONTACT.MANAGE.TIME.LINE.TIPS.5':
    '由 <span class={calssNames}>{operatorOrsource}</span> 修改 {value}',
  'CONTACT.MANAGE.TIME.LINE.TIPS.6':
    '<span class={calssNames}>{operatorOrsource}</span> 通过管理端更新订阅状态',
  'CONTACT.MANAGE.TIME.LINE.TIPS.7-1-1': '玩家通过落地页订阅',
  'CONTACT.MANAGE.TIME.LINE.TIPS.7-1-2':
    '<span class={calssNames}>{operatorOrsource}</span> 通过落地页订阅',
  'CONTACT.MANAGE.TIME.LINE.TIPS.7-2-1': '玩家通过落地页更新订阅状态为取消订阅',
  'CONTACT.MANAGE.TIME.LINE.TIPS.7-2-2':
    '<span class={calssNames}>{operatorOrsource}</span> 通过落地页更新订阅状态为取消订阅',
  'CONTACT.MANAGE.TIME.LINE.TIPS.8':
    '在 <span class="time-line-variable">{activityName}</span> 活动中，被投递',
  'CONTACT.MANAGE.TIME.LINE.TIPS.9':
    '由 <span class={calssNames}>{operatorOrsource}</span> 更新邮箱',
  'CONTACT.MANAGE.TIME.LINE.TIPS.10':
    '由 <span class={calssNames}>{operatorOrsource}</span> 更新OpenID',
  'CONTACT.MANAGE.TIME.LINE.TIPS.11':
    '由 <span class={calssNames}>{operatorOrsource}</span> 更新语言编码',
  'CONTACT.MANAGE.TIME.LINE.TIPS.12':
    '由 <span class={calssNames}>{operatorOrsource}</span> 更新区域',
  'CONTACT.MANAGE.TIME.LINE.TIPS.15':
    '由 <span class={calssNames}>{operatorOrsource}</span> 取消<span class="time-line-variable">{tagName}</span>标签',
  'CONTACT.MANAGE.TIME.LINE.TIPS.16-FILE':
    '文件上传：<span class={calssNames}>{operatorOrsource}</span> 新增偏好：<span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.16-SINGLE-ADD':
    '单独添加：<span class={calssNames}>{operatorOrsource}</span> 新增偏好：<span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.16-API':
    'API传入：<span class="time-line-variable">{source}</span> 新增<span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.16-LI-PASS':
    'LI官网传入：<span class="time-line-variable">{source}</span> 新增<span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.17-FILE':
    '文件上传：<span class={calssNames}>{operatorOrsource}</span> 移除偏好：<span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.17-SINGLE-ADD':
    '单独添加：<span class={calssNames}>{operatorOrsource}</span> 移除偏好：<span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.17-API':
    'API传入上传：<span class="time-line-variable">{source}</span> 移除<span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.17-LI-PASS':
    'LI官网传入：<span class="time-line-variable">{source}</span> 移除<span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.18':
    '玩家新增偏好：<span class="time-line-variable">{addPreference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.19':
    '玩家移除偏好：<span class="time-line-variable">{removePreference}</span>',

  // 时间线 - 涉及变量信息
  'CONTACTS.TIME.LINE.EMAIL': '邮箱',
  'CONTACTS.TIME.LINE.WHATSAPP': 'WhatsApp',
  'CONTACTS.TIME.LINE.SUBSCRIBE.SURE': '确认订阅',
  'CONTACTS.TIME.LINE.SUBSCRIBE.CANCEL': '取消订阅',
  'CONTACTS.TIME.LINE.SUBSCRIBE.RE': '重新订阅',
  'CONTACTS.TIME.LINE.SUBSCRIBE.PENDING': '待定',
  'CONTACTS.TIME.LINE.PREFERENCE': '偏好',
  'CONTACTS.TIME.LINE.TAG': '标签',
  'CONTACTS.TIME.LINE.LANGUAGE': '语言',
  'CONTACTS.TIME.LINE.REGION': '地区',
  'CONTACT.TIME.LINE.SOURCE.PLAYER': '联系人',
  'CONTACT.TIME.LINE.SOURCE.PLAYER.NAME': '联系人',
  'CONTACTS.TIME.LINE.PUNCTUATION.PAUSE': '，',
  'CONTACTS.TIME.LINE.PUNCTUATION.PARALLEL': '、',
  // 时间线 - 新增
  'CONTACTS.TIME.LINE.ADD.BY.CSV':
    '<span class="time-line-variable">{operator}</span> 通过CSV导入联系人 <span class="time-line-variable">{channelValue}</span>',
  'CONTACTS.TIME.LINE.ADD.BY.MANUAL':
    '<span class="time-line-variable">{operator}</span> 单个添加联系人',
  'CONTACTS.TIME.LINE.ADD.BY.API':
    'API <span class="time-line-variable">{channelName}</span> 导入联系人 <span class="time-line-variable">{channelValue}</span>',
  'CONTACTS.TIME.LINE.ADD.BY.FORM':
    '<span class="time-line-variable">联系人</span> 提交表单 <span class="time-line-variable">{formName}</span> ， 导入联系人邮箱',
  'CONTACTS.TIME.LINE.ADD.BY.OTHER':
    '<span class="time-line-variable">{source}</span> 导入联系人 <span class="time-line-variable">{channelValue}</span>',
  // 时间线 - 关联
  'CONTACTS.TIME.LINE.LINK.BY.USER':
    '<span class="time-line-variable">{operator}</span> 通过{source}关联联系人 <span class="time-line-variable">{channelValue}</span>',
  'CONTACTS.TIME.LINE.LINK.BY.OTHER':
    '<span class="time-line-variable">{source}</span> 关联联系人 <span class="time-line-variable">{channelValue}</span>',
  // 时间线 - 整合
  'CONTACTS.TIME.LINE.INTEGRATE.CHANNELS':
    'WhatsApp <span class="time-line-variable">{wuid}</span> 与 Email <span class="time-line-variable">{email}</span>，被整合生成双渠道联系人',
  // 时间线 - 更新
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.USER':
    '<span class="time-line-variable">{operator}</span> 通过<span class="time-line-variable">{source}</span>更新联系人信息',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.API':
    'API <span class="time-line-variable">{channelName}</span> 更新联系人信息',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.FORM':
    '<span class="time-line-variable">联系人</span> 提交表单 <span class="time-line-variable">{formName}</span> ， 更新联系人信息',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.DETAILS':
    '<span class="time-line-variable">{operator}</span> 联系人详情页编辑联系人信息',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.OTHER':
    '<span class="time-line-variable">{source}</span> 更新联系人信息',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.DISCORD':
    '联系人绑定<b class="time-line-variable">Discord</b>账号:',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.STEAM':
    '联系人绑定<b class="time-line-variable">Steam</b>账号:',
  'CONTACTS.TIME.LINE.INVITED.TO.TEST.TITLE':
    '联系人被邀请加入 <b class="time-line-variable">{journeyName}</b>',
  // 时间线 - 订阅状态
  'CONTACTS.TIME.LINE.SUB.SURE':
    '联系人 <span class="time-line-variable">{subscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.ADD':
    '{channelName}订阅状态：<span class="time-line-variable">{subscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.UPDATED':
    '{channelName}订阅状态更新为：<span class="time-line-variable">{subscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.UPDATED.FORM.TO':
    '{channelName}订阅状态从 <span class="time-line-variable">{oldSubscribe}</span> 更新为 <span class="time-line-variable">{newSubscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.UPDATED.IN.ACTIVITY':
    '<span class="time-line-variable">联系人</span> 在活动中将邮箱 <span class="time-line-variable">{newSubscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.UPDATED.FORM.TO.IN.JOURNEY.NODE':
    '<span class="time-line-variable">联系人</span> 在旅程 <span class="time-line-variable">{journeyName}</span> ，节点 <span class="time-line-variable">{nodeName}</span> 中将邮箱 <span class="time-line-variable">{subscribe}</span>',
  // 时间线 - 字段
  'CONTACTS.TIME.LINE.FILED.ADD':
    '新增 {filedName}：<span class="time-line-variable">{value}',
  'CONTACTS.TIME.LINE.FILED.UPDATE':
    '更新 {filedName}为：<span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.BIND.TAGS':
    '绑定标签：<span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.UNBIND.TAGS':
    '解绑标签：<span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.PREFERENCE.ADD':
    '新增偏好：<span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.PREFERENCE.REMOVE':
    '移除偏好：<span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.WAHTSAPP.INFERRED':
    '暂未导入用户{filedName}信息，根据区号 <span class="time-line-variable">{areaCode}</span> 推断并设置为 <span class="time-line-variable">{value}</span>',
  // 时间线 - 活动
  'CONTACTS.TIME.LINE.CLICK.ACTIVITY.LINK.BY.WHATSAPP':
    '<span class="time-line-variable">联系人</span> 点击了活动 <span class="time-line-variable">{activityName}</span> 中的链接 <span class="time-line-variable" title={hoverLinkUrl}>{showLinkUrl}</span>',
  'CONTACTS.TIME.LINE.CLICK.ACTIVITY.LINK.BY.EMAIL':
    '<span class="time-line-variable">联系人</span> 点击了活动 <span class="time-line-variable">{activityName}</span> 中的邮件链接 <span class="time-line-variable" title={hoverLinkUrl}>{showLinkUrl}</span>',
  'CONTACTS.TIME.LINE.OPEN.ACTIVITY.BY.EMAIL':
    '<span class="time-line-variable">联系人</span> 打开了活动 <span class="time-line-variable">{activityName}</span> 中的邮件',
  'CONTACTS.TIME.LINE.SUBMIT.ACTIVITY.BY.EMAIL':
    '<span class="time-line-variable">联系人</span> 提交了活动 <span class="time-line-variable">{activityName}</span> 中的表单 <span class="time-line-variable">{formName}</span>',
  'CONTACTS.TIME.LINE.READED.ACTIVITY.BY.WHATSAPP':
    '<span class="time-line-variable">联系人</span> 已读了活动 <span class="time-line-variable">{activityName}</span> 的信息',
  // 时间线 - 旅程
  'CONTACTS.TIME.LINE.CLICK.JOURNEY.NODE.LINK.BY.EMAIL':
    '<span class="time-line-variable">联系人</span> 点击了旅程 <span class="time-line-variable">{journeyName}</span> ，节点 <span class="time-line-variable">{nodeName}</span> 的邮件中的链接 <span class="time-line-variable" title={hoverLinkUrl}>{showLinkUrl}</span>',
  'CONTACTS.TIME.LINE.OPEN.JOURNEY.NODE.BY.EMAIL':
    '<span class="time-line-variable">联系人</span> 打开了旅程 <span class="time-line-variable">{journeyName}</span> ，节点 <span class="time-line-variable">{nodeName}</span> 的邮件',
  'CONTACTS.TIME.LINE.FILLIN.JOURNEY.NODE.FORM':
    '<span class="time-line-variable">联系人</span> 填写了旅程 <span class="time-line-variable">{journeyName}</span> ，节点 <span class="time-line-variable">{nodeName}</span> 中的表单 <span class="time-line-variable">{formName}</span>',
  'CONTACTS.TIME.LINE.ENTRY.JOURNEY':
    '进入旅程 <span class="time-line-variable">{journeyName}</span>',
  'CONTACTS.TIME.LINE.COMPLETED.JOURNEY':
    '完成了旅程 <span class="time-line-variable">{journeyName}</span>',
  // 时间线 - 投递（活动&旅程）
  'CONTACTS.TIME.LINE.ACTIVITY.DELIVERY.EMAIL':
    '邮箱被活动 <span class="time-line-variable">{activityName}</span> 投递',
  'CONTACTS.TIME.LINE.ACTIVITY.DELIVERY.WAHTSAPP':
    'WhatsApp号码被活动 <span class="time-line-variable">{activityName}</span> 投递',
  'CONTACTS.TIME.LINE.DOUBLEOPTIN.RECEIVED.EMAIL':
    '邮箱被投递了 <span class="time-line-variable">二次确认</span> 邮件',
  'CONTACTS.TIME.LINE.JOURNEY.NODE.DELIVERED.EMAIL':
    '邮箱被旅程 <span class="time-line-variable">{journeyName}</span>，节点 <span class="time-line-variable">{nodeName}</span> 投递',

  // 时间线 - 其他操作
  'CONTACTS.TIME.LINE.DISCORD.BIND.CONTENT.ADD':
    '<p>新增 Discord ID: <b class="time-line-variable">{DiscordId}</b></p>',
  'CONTACTS.TIME.LINE.DISCORD.BIND.CONTENT.UPDATE':
    '<p>更新 Discord ID: <b class="time-line-variable">{DiscordId}</b></p>',
  'CONTACTS.TIME.LINE.BIND.CONTENT.EMAIL.ADD':
    '<p>新增 账号邮箱: <b class="time-line-variable">{Email}</b></p>',
  'CONTACTS.TIME.LINE.BIND.CONTENT.EMAIL.UPDATE':
    '<p>更新 账号邮箱: <b class="time-line-variable">{Email}</b></p>',
  'CONTACTS.TIME.LINE.BIND.CONTENT.NICKNAME.ADD':
    '<p>新增 昵称: <b class="time-line-variable">{userName}</b></p>',
  'CONTACTS.TIME.LINE.BIND.CONTENT.NICKNAME.UPDATE':
    '<p>更新 昵称: <b class="time-line-variable">{userName}</b></p>',
  'CONTACTS.TIME.LINE.DISCORD.BIND.CONTENT.SERVER.ADD':
    '<p>联系人加入Discord服务器: <b class="time-line-variable">{ServerName} #{ChannelName}</b></p>',
  'CONTACTS.TIME.LINE.DISCORD.BIND.CONTENT.SERVER.UPDATE':
    '<p>更新 联系人加入Discord服务器: <b class="time-line-variable">{ServerName} #{ChannelName}</b></p>',
  'CONTACTS.TIME.LINE.STEAM.BIND.CONTENT.ADD': `<p>新增 Steam ID: <b class="time-line-variable">{SteamId}</b></p>`,
  'CONTACTS.TIME.LINE.STEAM.BIND.CONTENT.UPDATE': `<p>更新 Steam ID: <b class="time-line-variable">{SteamId}</b></p>`,
  'CONTACTS.TIME.LINE.INVITED.TO.TEST1.CONTENT':
    '<p>收到 邀请旅程-自定义发件节点：<b class="time-line-variable">{testerList}</b>，发送的邮件</p>',
  'CONTACTS.TIME.LINE.INVITED.TO.TEST2.CONTENT': '<p>联系人接受邀请</p>',
  'CONTACTS.TIME.LINE.DISCORD.CONTACT.MERGE':
    '<b class="time-line-variable">{Email}</b> 绑定Discord账号 (Discord ID：<b>{DiscordId}</b>) 联系人合并,更新联系人信息',
  'CONTACTS.TIME.LINE.STEAM.CONTACT.MERGE':
    '<b class="time-line-variable">{Email}</b> 绑定Steam账号 (Steam ID：<b>{SteamId}</b>) 联系人合并,更新联系人信息',

  // 上传excel - 来源
  'CONTACT.MANAGE.CREATE.SOURCE.TITLE': '来源',
  'CONTACT.MANAGE.CREATE.SOURCE.DESC': '选择导入联系人的来源',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL': '通过上传CSV文件',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL.EXTRA':
    '从你的电脑中选择一个CSV格式的文件',
  'CONTACT.MANAGE.CREATE.SOURCE.WHATSAPP.UPLOAD.LABEL.EXTRA':
    '通过CSV可导入email和WhatsApp号码',
  'CONTACT.MANAGE.CREATE.SOURCE.WHATSAPP.UPLOAD.LABEL.EXTRA.TIPS':
    'CSV支持导入WhatsApp号码。（其他方式暂不支持导入WhatsApp号码）',
  'CONTACT.MANAGE.CREATE.SOURCE.API.LABEL': '通过API',
  'CONTACT.MANAGE.CREATE.SOURCE.API.LABEL.DESC': '获取更多通过API导入的信息',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL.EXTRA.L': '请到',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL.EXTRA.C': '文件中心',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL.EXTRA.R': '去查看文档',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.A.SUBS.LABEL': '添加一个单独联系人',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.A.SUBS.LABEL.EXTRA': '填入一个联系人',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.LIPASS.LABEL': 'LEVEL INFINITE PASS',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.LIPASS.LABEL.EXTRA':
    '将玩家从 LEVEL INFINITE PASS 同步到SmartLink联系人',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.WHITE.LABEL.EXTRA':
    '将玩家从 {title} 同步到SmartLink联系人',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.LIPASS.AUTHORISED': '已授权',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.LIPASS.NOT.AUTHORISED': '未授权',
  'CONTACT.MANAGE.CREATE.SOURCE.THIRD.PART.PLATFORMS': '来自第三方平台',
  'CONTACT.MANAGE.CREATE.SOURCE.NEWSLETTER.LABEL':
    '订阅通讯来自LEVEL INFINITE PASS',
  'CONTACT.MANAGE.CREATE.SOURCE.NEWSLETTER.LABEL.EXTRA':
    '订阅通讯来自LEVEL INFINITE PASS',
  'CONTACT.MANAGE.CREATE.SOURCE.NEWSLETTER.ON': '开启',
  'CONTACT.MANAGE.CREATE.SOURCE.NEWSLETTER.OFF': '关闭',

  // 联系人上传文件
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS': '新增联系人',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.UPLOAD.DIS':
    '单次最多可上传{ num }个文件',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.DROP.FILES':
    '选择您的文件或拖放文件至此处',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.DROP.FILES.LIMIT':
    '仅支持csv格式，文件大小限制在20MB以内',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.DROP.FILES.DECODE':
    '导入文件需要使用UTF-8编码',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.UPLOADING': '上传您的文件',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.UPLOADED': '您的文件已上传！',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.DOWNLOAD.SAMPLE.NAME':
    '上传联系人邮箱模板',
  'CONTACT.MANAGE.CREATE.SOURCE.CONTINUR': '继续',
  'CONTACT.MANAGE.CREATE.SOURCE.GO.SETTING': '去设置',
  'CONTACT.MANAGE.CREATE.SOURCE.MATCH.CONTINUR.TIPS': '未发现Email无法继续导入',
  'CONTACT.MANAGE.CREATE.SOURCE.MATCH.CONTINUR.WHATSAPP.TIPS':
    '未发现Email或WhatsApp无法继续导入',
  'CONTACT.MANAGE.CREATE.SOURCE.PREVIOUE': '上一步',
  'CONTACT.MANAGE.CREATE.SOURCE.VIEW.API': '查看API指引',
  'CONTACT.MANAGE.CREATE.SOURCE.PERCENT': '数据读取中 ({percent}%)',
  'CONTACT.MANAGE.CREATE.SOURCE.COMPLETE': '确认上传',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD': '上传文件',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MACH': '匹配字段',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPDATE.CONTACTS': '更新联系人',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS': '订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.PREFERENCE': '偏好设置',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG': '标签绑定',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW': '检查',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.TITLE': '上传您的文件',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CODE': '区域代码&语言代码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.WHATSAPP.CODE':
    'WhatsApp区号&国家映射关系',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.EXAMPLE': '下载 csv 文件示例',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.DESC.1':
    '上传文件批量导入联系人，支持导入联系人相关的所有信息。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.DESC.2':
    '鼓励导入系统字段，也可自定义字段。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.NORM': '系统字段导入规范',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.RL.TITLE': '区域&语言',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.RL.1':
    '导入国家和语言，需参考提供的国家和语言编码，填入对应国家和语言的编码到CSV文件中',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.UPLOAD.INFO.RL.1':
    '当导入whatsApp号码无联系人地区信息时，自动使用此映射关系为联系人赋予对应的国家信息。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.TP.TITLE':
    '标签&偏好&Drop down类型字段',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.TP.1':
    '标签、偏好、Drop down字段的选项只接受已在系统内创建的值',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.TP.2':
    '· 为单个联系人导入多个标签、偏好名称、字段选项时，可使用“;”“|”作为分隔符',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.TP.3':
    '· 在 CSV 文件的首行中，这些属性可以命名为“偏好”和“标签”。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.DT.TITLE': '日期&时间',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.DT.1':
    '日期字段必须包含时区，仅支持以下两种格式',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.1':
    '这个上传将更新联系人列表中的联系人信息，不包括订阅状态。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.2':
    '对于每个联系人，除了电子邮件地址、语言和区域，你还可以包括其他属性（姓名，生日，性别，等等）。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.3':
    '日期类型字段需标明时区，且暂时仅支持如下两种格式：',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.4':
    '<span class="contact-upload-info-time">· 2001-03-07+08:00</span><span class="contact-upload-info-time">· 2001-03-07 00:00:00+08:00</span>',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.5':
    '偏好字段、标签字段，仅可传入偏好页面和标签列表页已创建的内容。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.6':
    '· csv首行标题可填入：偏好/标签;',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.7':
    '· 如需为单个用户标记多个偏好，则多个偏好/标签之前需用|间隔',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.8':
    '传入的联系人信息会使你能够细分你的名单，并使你的活动个性化！',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.CREATE': '创建新字段',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.PROPETRY': '字段',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.PROPETRY.MSG':
    '字段格式不符合规则',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.PROPETRY.MSG.RPT':
    '字段不能和已有表头重复',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.PROPETRY.HOLDER':
    '输入名称',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.TYPE': '类型',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.TYPE.MSG':
    '请选择类型',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.LIMIT.SIZE':
    '上传文件大小不能超过20M',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.LIMIT.NUM':
    '最多可上传{num}个文件',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.LIMIT.NAME.LENGTH':
    '文件名称过长，请修改到255个字符以内',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.MSG': '文件上传错误',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.MSG.TYPE': '请上传csv文件',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MACH.STAT':
    '<span class={importClass}>{passNum}</span> 列将会被导入，<span class={unImportClass}>{unPassNum}</span> 列不会被导入。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MACH.TEADER.INFO':
    '此列无法导入，选择已有字段，或新增字段后可导入',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MACH.FILED.USED': '已经被使用',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.TITLE': '组织你的联系人',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB': '选择订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.EMAIL.FILE.TAG.SUB.TITLE': 'Email 订阅状态设置',
  'CONTACT.MANAGE.CREATE.SOURCE.WHATSAPP.FILE.TAG.SUB.TITLE':
    'WhatsApp订阅状态设置',
  'CONTACT.MANAGE.CREATE.SOURCE.EMAIL.FILE.TAG.SUB': 'Email 订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.WHATSAPP.FILE.TAG.SUB': 'WhatsApp订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.SUB.STATUS.NOT.SET': '未设置',
  'CONTACT.MANAGE.CREATE.SOURCE.SUB.STATUS.SET': '已设置',
  'CONTACT.MANAGE.CREATE.SOURCE.SUB.STATUS.AUTO': '自动设置',
  // 'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.UPDATE.EXTRA':
  //   'lf we spot a duplicate emil in your import, well automatically replace the existing oontact information with the new data.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.CREATE': '查询或创建标签',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.CREATE.DESC':
    '可以直接向与此标签绑定的联系人发送电子邮件，并且可以创建与此标签相关的细分规则。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.AND.4':
    '系统内已存在的已订阅或未订阅的联系人，不再更新订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1': '已订阅',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.RECOM': '建议选择',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.DESC':
    '导入用户的订阅状态更新为已订阅，项目内未订阅用户订阅状态不更新，订阅状态以外其他信息都正常更新。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.TAG.SUB.1.DESC':
    '新导入的联系人的whatsApp订阅状态会更新为已订阅。已存在联系人的WhatsApp未订阅状态不更新；',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.EXTRA':
    '当你选择“已订阅”状态，意味着你已经获得了向他们发送邮件的可以许可。了解更多信息关于“<a href="{ url }" target="_blank">获得许可</a>”的信息。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.TAG.SUB.1.EXTRA':
    '当你选择“已订阅”状态，意味着你已经获得了向他们发送WhatsApp消息的许可。了解更多信息关于“<a href="{ url }" target="_blank">获得许可</a>”的信息。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.TAG.SUB.0.EXTRA':
    '活动无法向“未订阅”联系人发送消息，请谨慎选择。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.TAG.SUB.-1.EXTRA':
    '活动无法向“未知”联系人发送消息。“未知”状态可通过后续导入联系人信息等方式更新订阅状态。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.OPTIONS.1':
    '更新已有联系人订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.OPTIONS.2':
    '更新已有联系人订阅状态，未订阅除外',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.OPTIONS.3':
    '不更新已有联系人订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.2.DESC':
    '导入用户的订阅状态更新为已订阅，项目内未订阅用户订阅状态不更新，订阅状态以外的其他信息，只有已订阅用户正常更新，未订阅用户不更新。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.2.EXTRA':
    '导入用户的订阅状态更新为已订阅，项目内未订阅用户订阅状态不更新，订阅状态以外的其他信息，只有已订阅用户正常更新，未订阅用户不更新。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.2.OPTIONS.1':
    '更新已有联系人订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.3.DESC':
    '导入用户的订阅状态均更新为已订阅，订阅状态以外其他信息都正常更新。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.3.EXTRA':
    '导入用户的订阅状态均更新为已订阅，订阅状态以外其他信息都正常更新。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.4': '未订阅',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.4.DESC':
    '导入用户的订阅状态均更新为未订阅，订阅状态以外其他信息都正常更新。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.4.EXTRA':
    '常规活动无法向“未订阅”联系人发件，但当不区分订阅状态选择全部联系人时，可以向“未订阅”联系人发件。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.5': '未知',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.5.DESC':
    '本次导入的新用户的订阅状态均更新为未知，订阅状态以外其他信息都正常更新。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.5.EXTRA':
    '常规活动无法向“未知”联系人发件，但当不区分订阅状态选择全部联系人时，可以向“未知”联系人发件。“未知”状态可通过后续导入联系人信息等方式更新。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS.PREFERENCES.LABEL':
    '设置联系人偏好',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS.PREFERENCES.EXTRA':
    '请提前在偏好设置页面设置偏好',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS.UPDATE.CHECKBOX.LABEL':
    '更新已存在联系人信息',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS.UPDATE.CHECKBOX.EXTRA':
    '如果导入联系人已存在你的联系人列表中，我们会使用你的导入数据自动替换和填充联系人信息。勾选此项，会使导入时间更长。',
  'CONTACT.MANAGE.CREATE.WHATSAPP.SOURCE.FILE.STATUS.UPDATE.CHECKBOX.EXTRA':
    '1. 若导入的Email/WhatsApp联系人已存在，系统将自动用新数据覆盖原有信息（勾选此项会延长导入时间）。<p class="pt-10">2. 此选项不影响WhatsApp或Email的直接更新匹配。</p>',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.CREATE.BTN': '创建',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.LIMIT.NUM': '最多可添加 {num} 个标签',

  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.TAGS': '绑定标签',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.SUB': '订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EMAIL.SUB': '邮箱订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.WHATSAPP.SUB': 'WhatsApp订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.TOTAL': '总共导入',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.SUCCESS': '成功导入',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION': '异常数据',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.TITLE': '查看并确认您的导入',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.DOWN':
    '下载导入日志.csv文件',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.EMAIL.NOT.FOUND':
    '无效邮箱地址 - 邮箱为空',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.EMAIL':
    '无效的邮箱地址 - 格式错误',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.REPEACT.EMAIL':
    '重复的邮箱地址',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.LOCATION':
    '无效的地区编码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.LANGUAGE':
    '无效的语言编码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.PREFERENCE':
    '无效的偏好',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.TAG':
    '无效的标签',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.TAG.TOTAL':
    '标签数量超出限制，单个联系人最多上{tagMaxNum}个标签',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.EMAIL.DOMIAN.ERROR':
    '无效邮箱地址 - 无效的邮箱域名',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.DROPDOWN':
    '无效的{name}',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.TYPE':
    '无效的 {name} - 格式错误',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.NOT.REQUIRE.FIELD':
    '必填字段缺失',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.WHATSAPP.INVALID':
    '无效WhatsApp号码-格式错误',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.WHATSAPP.REPEAT':
    '重复的WhatsApp号码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.EMAIL.NOT.FOUND':
    '{num} 行空邮箱',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.EMAIL':
    '{num} 行无效的邮箱地址',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.REPEACT.EMAIL':
    '{num} 行重复的邮箱地址',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.LOCATION':
    '{num} 行无效的地区编码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.LANGUAGE':
    '{num} 行无效的语言编码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.PREFERENCE':
    '{num} 行无效的偏好',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.TAG':
    '{num} 行无效的标签',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.TAG.TOTAL':
    '{num} 行标签数量超出限制',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.TYPE':
    '{num} 行类型无效',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.DROPDOWN':
    '{num} 行无效的{name}',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.EMAIL.DOMIAN.ERROR':
    '{num} 行无效的邮箱域名',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.NOT.REQUIRE.FIELD':
    '{num} 行必填字段缺失',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.WHATSAPP.INVALID':
    '{num} 行无效的WhatsApp号码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.WHATSAPP.REPEAT':
    '{num} 行重复的WhatsApp号码',
  // 'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.LABEL':
  //   'I confirm that my new import adheres to these conditions',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT':
    '我确认我本次导入遵守这些条件：',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.EXTRA.1':
    '我的联系人在过去两年内明确表示允许我发送邮件（新闻快报），或在过去两年内被要求发送邮件（新闻快报）。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.EXTRA.2':
    '这些联系人不是从第三方借来的。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.EXTRA.3':
    '这些联系人不是购买或租用的。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.EXTRA.4':
    '我们可以随时暂停或取消向不符合上述条件的联系人发送的任何电子邮件。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.QUIT.TITLE': '确定退出创建联系人？',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.QUIT.DESC':
    '退出后，已上传数据不会被保存。',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.READFILE.HEADER.MSG':
    '表头信息不能为空',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.READFILE.MSG': '数据解析失败',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.ANALYZE.MSG': '文件解析错误',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.NO.DATA':
    '暂无数据，请填写数据后再上传',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MORE.INFO':
    '<a href="{ url }" target="_blank">更多信息</a>',
  // 联系人列表数据入库进度
  'CONTACT.MANAGE.PROGRESS.LI': '从LI PASS导入联系人({progress}%)',
  'CONTACT.MANAGE.PROGRESS.FILE': '联系人导入中({progress}%)',
  'CONTACT.MANAGE.PROGRESS.UPLOADED': '已上传 {count} 位联系人',
  'CONTACT.MANAGE.PROGRESS.NAME.UPLOADED': '{name} {count} 联系人已上传',
  'CONTACT.MANAGE.PROGRESS.FILE.IPLOADING': '当前{num}个联系人正在导入中...',
  'CONTACT.MANAGE.CREATE.SUB.LIMIT.RADIUS':
    '限制输入范围-9223372036854775808 ~ 9223372036854775807',
  // 地点编码选择弹窗
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.TIPS':
    'SmartLink识别到您上传的文件中包含地区编码列',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.LABEL': '请选择编码类型',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.THREE.DIGIT': '三位数字码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.THREE.DIGIT.TIPS':
    '像 “004”',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.TWO.LETTER': '两位字母码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.TWO.LETTER.TIPS': '像 “AF”',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.THREE.LETTER': '三位字母码',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.THREE.LETTER.TIPS':
    '像 “AFG”',

  // 手动上传单个联系人
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.ALLOW.SEND.EMAIL':
    '我已经获得了所有联系人的明确知情同意，可以向他们发送消息。',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.UPDATE.EAMIL.INFO':
    '如果用户已在系统内存在，则更新用户信息（订阅状态除外）',
  'CONTACT.MANAGE.CREATE.SUB.DESC.TITLE': '可在此为联系人写入所有字段信息',
  'CONTACT.MANAGE.CREATE.SUB.DESC.SMALL1': '如需传入更多字段，请到',
  'CONTACT.MANAGE.CREATE.SUB.DESC.SMALL2': '用户属性',
  'CONTACT.MANAGE.CREATE.SUB.DESC.SMALL3': '页面添加',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.LABEL': '邮箱',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.PLACEHOLDER': '请输入邮件地址',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.ERROR': '邮件地址格式错误',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.VALIDATOR.ERROR': '无效的邮箱域名',
  'CONTACT.MANAGE.CREATE.SUB.PREFERENCE': '偏好',
  'CONTACT.MANAGE.CREATE.SUB.PLEASE.SELECT.PREFERENCE': '请选择偏好',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.TAG.EMPTY': '去创建标签',
  'CONTACT.MANAGE.CREATE.SUB.LIMIT.LENGTH': '请输入{name},上限1000字符',

  // 预约设置
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.TITLE':
    'LEVEL INFINITE PASS 订阅设置',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.DETAILS': '设置详情',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.SWITCH': '打开/关闭',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.SWITCH.INFO.1':
    '打开开关表明LEVEL INFINITE PASS  网站的订阅者可以被收集到 SmartLink 中。',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.SWITCH.INFO.2':
    '<a href="{url}" target="_blank">了解更多</a>',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL': '设置欢迎电子邮件',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.INFO.1':
    '当开关打开后，LEVEL INFINITE PASS 的官网订阅者将在订阅后收到一封欢迎邮件。',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SENDER.INFO': '发件人信息',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.CONTENT': '内容',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.DEFAULT.LANGUAGE': '默认语言',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SUBJECT': '主题',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SUBJECT.PLACEHOLDER':
    '输入主题',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.FORM': '发件地址',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.TEMPLATE': '邮件模板',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.TEMPLATE.PLACEHOLDER':
    '请选择一个模板',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.PREVIEW': '预览',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.PREVIEW.NONE':
    '请选择一个模板',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.TEST': '发送测试邮件',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.TITLE':
    '添加电子邮件地址用以接收测试邮件',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.ADD.EMAIL':
    '手动添加电子邮件',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.ADD.EMAIL.PLACEHOLDER':
    '每行输入一个电子邮件地址',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.STATISTICS':
    '共<span class={colorError}>{num}</span> / {maxNum} 封电子邮件',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND': '发送',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.RETURN.INTERCEPT.TITLE':
    '是否确认返回？',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.RETURN.INTERCEPT.DESC':
    '更改将不会被保存',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.CONTENT.ERROR.MSG':
    '请检查{lang}语言内容是否填写正确',

  // 标签
  'CONTACT.MANAGE.CREATE.ADD.TAGS.TITLE': '添加标签',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.DESC': '可在【标签管理】新建标签',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.CARD.TITLE':
    '标签可以帮助您直接向已打上该标签的联系人发送邮件，同时可以创建与该标签相关的细分市场。',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.CARD.PLACEHOLSER':
    '以下是您为联系人打上的标签',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.ALL': '所有标签',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.NEW': '新标签',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.NAME': '请输入Tag name，上限100字符',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.NAME.RPT': '此标签已被占用',
  'CONTACT.MANAGE.CREATE.SUBMIT.DIS': '文件上传完毕且选择标签后可提交',
  'CONTACT.MANAGE.DETAIL.PUTAWAY': '收起',
  'CONTACT.MANAGE.DETAIL.PERSONAL.INFO.TITLE': '个人信息',
  'CONTACT.MANAGE.DETAIL.PERSONAL.INFO.CARD.TITLE': '邮箱',
  'CONTACT.MANAGE.DETAIL.TAGS.TITLE': '标签',
  'CONTACT.MANAGE.DETAIL.TAGS.DEL.TITLE': '确定删除此标签吗？',
  'CONTACT.MANAGE.DETAIL.TAGS.DEL.DESC': '删除此标签后，该联系人不再关联此标签',
  'CONTACT.MANAGE.DELETE.USER.PERMANENTLY': '永久删除用户信息',
  'CONTACT.MANAGE.DETAIL.DELETE.MSG': '确定删除联系人？',
  'CONTACT.MANAGE.DETAIL.DEL.TIPS': '删除后，联系人信息不可恢复。',
  'CONTACT.MANAGE.COUNTRY.LANG.STATISTICS.TIPS':
    '总共<b class="color-primary font-size-20 font-poppins">{total}</b> 订阅者',
  'CONTACT.MANAGE.COUNTRY.LANG.STATISTICS.INFO':
    '为了降低退信率，当您需要在24小时内投递超过100万封邮件时，请提前1个工作日通过邮箱联系SmartLink团队<span class="color-primary">（{customerServiceEmail}）</span>获取支持。',

  // 字段设置
  'FIELD.SETTINGS.LIST.TITLE': '用户属性',
  'FIELD.SETTINGS.CREATE.FIELD.BTN': '创建字段',
  'FIELD.SETTINGS.LIST.TIPS':
    '勾选是否可见行或更改排序，保存后将显示在联系人列表中',
  'FIELD.SETTINGS.PREFERENCE.TIPS1':
    '标识联系人的订阅偏好，选项设置完成后，可添加链接到邮件内容中供用户更新。',
  'FIELD.SETTINGS.PREFERENCE.TIPS2': '更多信息',
  'FIELD.SETTINGS.LIST.FIELD.SORT': '排序',
  'FIELD.SETTINGS.LIST.FIELD.VISIBLE': '可见',
  'FIELD.SETTINGS.LIST.FIELD.VISIBLE.TIPS':
    '可以显示或隐藏联系人列表中的该字段',
  'FIELD.SETTINGS.LIST.FIELD.NAME': '字段名称',
  'FIELD.SETTINGS.LIST.FIELD.TYPE': '字段类型',
  'FIELD.SETTINGS.CREATE.FIELD': '创建字段',
  'FIELD.SETTINGS.EDIT.FIELD': '编辑字段',
  'FIELD.SETTINGS.NAME': '名称',
  'FIELD.SETTINGS.PLEASE.ENTER.NAME': '请输入名称',
  'FIELD.SETTINGS.NAME.NOT.EMPTY': '名称不能为空',
  'FIELD.SETTINGS.NAME.CHAR.RESTRICTIONS':
    '只能包含英文字母、数字和下划线，且必须以字母开头',
  'FIELD.SETTINGS.TYPE': '类型',
  'FIELD.SETTINGS.PLEASE.SELECT.TYPE': '请选择类型',
  'FIELD.SETTINGS.OPTION.NAME': '选项名称',
  'FIELD.SETTINGS.OPTION.NAME.PLACEHOLDER': '请输入选项名称',
  'FIELD.SETTINGS.OPTION.NAME.NOT.EMPTY': '选项名称不能为空',
  'FIELD.SETTINGS.OPTION.NAME.REP': '输入的选项名称有重复，请检查',
  'FIELD.SETTINGS.LIST.DEL.TITLE': '确定删除联系人字段？',
  'FIELD.SETTINGS.LIST.DEL.DESC':
    '删除 <b class="color-333">{name}</b> 后，字段信息不可恢复。',
  'FIELD.SETTINGS.LIST.DEL.TIPS': '该字段被API使用，无法删除',
  'FIELD.SETTINGS.LIST.SYSTEM.DISABLED.EDIT.TIPS': '系统字段不可编辑',
  'FIELD.SETTINGS.LIST.SYSTEM.DISABLED.DEL.TIPS': '系统字段不允许被删除',
  'FIELD.SETTINGS.LIST.LEAVE.PAGE.TITLE': '温馨提示',
  'FIELD.SETTINGS.LIST.LEAVE.PAGE.MESSAGE': '当前内容已经修改，确定是否保存？',
  'FIELD.SETTINGS.BUILT.IN': '(内置)',
  'FIELD.SETTINGS.SAME.SYSTEM.ATTRIBUTE': '与系统字段名称重复，请勿创建',
  'FIELD.SETTINGS.EMAIL.SEND.DETAILS': 'Email-发送详情',
  'FIELD.SETTINGS.WHATSAPP.SEND.DETAILS': 'WhatsApp-发送详情',
  'FIELD.SETTINGS.SEND.DETAILS': '发送详情',
  'FIELD.SETTINGS.SEND.DETAILS.TIPS':
    '字段作为个人信息插入到邮件模板或主题中，此处可查看发送的详细信息。',
  'FIELD.SETTINGS.SEND.VALUE': '发送值',

  // 导入历史
  'IMPORT.HISTORY.LIST.EXPORT.BTN.TIPS': '仅支持导入用户导出',
  'IMPORT.HISTORY.LIST.IMPORTED.TIME': '导入时间',
  'IMPORT.HISTORY.LIST.CREATED.BY': '创建者',
  'IMPORT.HISTORY.LIST.SUCCESS': '成功',
  'IMPORT.HISTORY.LIST.EXCEPTION': '异常',
  'IMPORT.HISTORY.LIST.PROCESS': '处理',
  'IMPORT.HISTORY.LIST.UPLOAD.CSV.FILE': '已上传的CSV文件',
  'IMPORT.HISTORY.LIST.SUCCESSFUL.LOGS': '成功日志',
  'IMPORT.HISTORY.LIST.EXCEPTION.LOGS': '异常日志',
  'IMPORT.HISTORY.LIST.UNSUBSCRIBERS': '取消订阅者',
  'IMPORT.HISTORY.LIST.NOT.UNSUBSCRIBERS.DOWNLOAD': '暂无取消订阅用户可下载',
  'IMPORT.HISTORY.LIST.NOT.FAIL.DOWNLOAD': '联系人均成功导入无失败数据',
  'IMPORT.HISTORY.LIST.IN.FORMATION.TIPS':
    '该列表正在生成，导入完成后可以下载查看',

  // 删除历史
  'DELETE.HISTORY.LIST.DEL.TIME': '删除时间',
  'DELETE.HISTORY.LIST.DEL.USER.NUM': '删除用户量',
  'DELETE.HISTORY.LIST.OPERATOR': '操作人',
  'DELETE.HISTORY.LIST.ROLE': '角色',
  'DELETE.HISTORY.LIST.DEL.ACTION': '删除方式',
  'DELETE.HISTORY.LIST.BATCH.DEL': '批量删除',
  'DELETE.HISTORY.LIST.SINGLE.DEL': '单个删除',
  // 注册表单 - 列表
  'SIGN.UP.FORM.TITLE.DESC':
    '创建一个可自定义字段并分享到其他网站或移动端的表单。玩家填写表单后可将表单信息收集到联系人列表。',
  'SIGN.UP.FORM.TITLE.CREATE': '创建表单',
  'SIGN.UP.FORM.TITLE.ADD': '新建表单',
  'SIGN.UP.FORM.CREATE.AND.SHAER': '创建表单并分享',
  'SIGN.UP.FORM.CREATE.AND.SHAER.DESC':
    '创建一个可自定义字段并分享到其他网站或移动端的表单',
  'SIGN.UP.FORM.CREATE.GET': '收集联系人列表',
  'SIGN.UP.FORM.CREATE.GET.DESC': '玩家填写表单后可将表单信息收集到联系人列表',
  'SIGN.UP.FORM.CREATE': '创建表单',
  'SIGN.UP.FORM.CREATE.DESC': '请先创建表单',
  'SIGN.UP.FORM.LIST.TITLE': '表单列表',
  'SIGN.UP.FORM.LIST.SEARCH.PLACEHOLDER': '请输入表单名称',
  'SIGN.UP.FORM.LIST.NAME': '表单名称',
  'SIGN.UP.FORM.LIST.NAME.PLACEHOLDER': '请输入名称',
  'SIGN.UP.FORM.LIST.NUMBER.OF.CONTACTS': '联系人数量',
  'SIGN.UP.FORM.LIST.TAGS': '标签',
  'SIGN.UP.FORM.LIST.STATUS': '状态',
  'SIGN.UP.FORM.LIST.STATUS.1': '激活',
  'SIGN.UP.FORM.LIST.STATUS.NEW.1': '已激活',
  'SIGN.UP.FORM.LIST.STATUS.2': '未激活',
  'SIGN.UP.FORM.LIST.DELETE.MSG': '确定删除表单?',
  'SIGN.UP.FORM.LIST.DEL.TIPS':
    '删除 <b class="color-333">{name}</b> 后，表单信息不可恢复。对联系人的筛选及统计将不再显示此信息。',
  'SIGN.UP.FORM.LIST.VIEW.REPORT': '查看报表',
  'SIGN.UP.FORM.LIST.VIEW.REPORT.DIALOG.TITLE':
    '表单总人数统计&二次确认邮件发送情况',
  'SIGN.UP.FORM.LIST.VIEW.REPORT.SUB.TITLE1': '表单总人数统计',
  'SIGN.UP.FORM.LIST.VIEW.REPORT.SUB.TITLE2': '二次确认邮件发送情况',

  // 请输入名称 - 创建、编辑、详情
  'SIGN.UP.FORM.LEAVE.PROMPT.TITLE': '确认退出表单创建？',
  'SIGN.UP.FORM.LEAVE.PROMPT.DESC': '退出前，请选择是否要保存本次设置内容',
  'SIGN.UP.FORM.ACTIVITY.EDIT.TOAST': '激活状态下表单不可编辑',
  'SIGN.UP.FORM.STEP.PLEASE.ENTER.NAME': '请输入名称',
  'SIGN.UP.FORM.STEP.CREATE': '创建',
  'SIGN.UP.FORM.STEP.SETTING': '设置',
  'SIGN.UP.FORM.STEP.RELEASE': '发布',
  'SIGN.UP.FORM.STEP.CONTINUE': '下一步',
  'SIGN.UP.FORM.STEP.SETTING.SAVE.CONTINUE': '保存并继续',
  'SIGN.UP.FORM.STEP.ADD.COMPONENT': '添加组件',
  'SIGN.UP.FORM.STEP.ADD.TITLE': '标题',
  'SIGN.UP.FORM.STEP.ADD.TITLE.TIPS': '可选择保留主标题或副标题',
  'SIGN.UP.FORM.STEP.ADD.ATTRIBUTE': '字段',
  'SIGN.UP.FORM.STEP.ADD.ATTRIBUTE.TIPS': '可将联系人字段放置在表单上',
  'SIGN.UP.FORM.STEP.ADD.PREFERENCE': '偏好',
  'SIGN.UP.FORM.STEP.ADD.PREFERENCE.TIPS': '可选择偏好模块设置好的偏好项',
  'SIGN.UP.FORM.STEP.ADD.PREFERENCE.DISABLED.TIPS': '请先创建偏好',
  'SIGN.UP.FORM.STEP.ADD.AGREEMENT': '协议',
  'SIGN.UP.FORM.STEP.ADD.AGREEMENT.TIPS': '可选择是否保留勾选框',
  'SIGN.UP.FORM.STEP.ADD.CAPTCHA': '验证码',
  'SIGN.UP.FORM.STEP.ADD.CAPTCHA.TIPS': '需注册后将账号信息填写回此处',
  'SIGN.UP.FORM.STEP.TITLE': '标题',
  'SIGN.UP.FORM.STEP.MAIN.TITLE': '标题',
  'SIGN.UP.FORM.STEP.SUB.TITLE': '副标题',
  'SIGN.UP.FORM.STEP.LINK': '链接',
  'SIGN.UP.FORM.STEP.CANCEL.LINK': '取消链接',
  'SIGN.UP.FORM.STEP.LABEL.NAME': '标签名称',
  'SIGN.UP.FORM.STEP.HELP.TEXT': '帮助文本',
  'SIGN.UP.FORM.STEP.EMBEDDED.TEXT': '内嵌文本',
  'SIGN.UP.FORM.STEP.CHECKBOX': '勾选框',
  'SIGN.UP.FORM.STEP.REQUIRED.FIELD': '必填字段',
  'SIGN.UP.FORM.STEP.SELECT.OPTIONS': '选择选项',
  'SIGN.UP.FORM.STEP.SELECT.OPTIONS.SELECTED.LEN': '{len}项被选',
  'SIGN.UP.FORM.STEP.QUESTION.TYPE': '题型设置',
  'SIGN.UP.FORM.STEP.QUESTION.TYPE.SINGLE': '单选',
  'SIGN.UP.FORM.STEP.QUESTION.TYPE.MULTIPLE': '多选',
  'SIGN.UP.FORM.STEP.SELECT.FIELD.HEIGHT': '输入框尺寸',
  'SIGN.UP.FORM.STEP.SINGLE.LINE': '单行',
  'SIGN.UP.FORM.STEP.MULTI.LINE': '多行',
  'SIGN.UP.FORM.STEP.SELECT.FIELD.WIDTH': '输入框尺寸',
  'SIGN.UP.FORM.STEP.WIDE': '宽',
  'SIGN.UP.FORM.STEP.NARROW': '窄',
  'SIGN.UP.FORM.STEP.COMPONENT.DEL.TITLE': '删除组件',
  'SIGN.UP.FORM.STEP.COMPONENT.DEL.TIPS': '你确定要删除这个组件？',
  'SIGN.UP.FORM.STEP.PLEASE.ADD.EMAIL.ATTR': '请添加邮箱字段',
  'SIGN.UP.FORM.STEP.PLEASE.ADD.OPTIONS': '请添加{name}选项',
  'SIGN.UP.FORM.STEP.PLEASE.ADD.CAPTCHA': '请添加验证码组件',
  'SIGN.UP.FORM.STEP.NO.ATTR.AVAILABLE.1': '无字段',
  'SIGN.UP.FORM.STEP.NO.ATTR.AVAILABLE.2': '无字段可选，请创建',
  'SIGN.UP.FORM.STEP.NO.CONFIG': '暂无配置',
  'SIGN.UP.FORM.STEP.CREATE.NO.SELECT': '请选中表单字段后开始编辑',
  'SIGN.UP.FORM.STEP.CREATE.PREVIEW.NO.SELECT': '当前只支持查看',
  'SIGN.UP.FORM.STEP.SETTING.CONTACT.TITLE': '标记联系人',
  'SIGN.UP.FORM.STEP.SETTING.CONTACT.DESC':
    '联系人正式加入列表后，自动绑定下方标签。',
  'SIGN.UP.FORM.STEP.SETTING.TAGS.NONE': '无标签添加',
  'SIGN.UP.FORM.STEP.SETTING.TAGS.DEL.TITLE': '确认删除此标签？',
  'SIGN.UP.FORM.STEP.SETTING.TAGS.DEL.DESC':
    '标签删除后，后续通过此表单加入的联系人将不再绑定此标签，请谨慎操作。',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.TITLE': '联系人加入策略',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.DESC':
    '若未设置，联系人提交表单会直接加入联系人列表。<br/>您可以为表单设置用户旅程 ',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.SETTING': '去设置',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.NOTE': '提示：',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.AUTOMATE.1':
    '用户旅程可为通过表单进入的玩家发送二次确认邮件，确认后联系人才加入您的联系人列表:',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.AUTOMATE.2':
    '用户旅程可为新加入的联系人发送欢迎邮件',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.DOUBLE': '双重确认设置',
  'SIGN.UP.FORM.STEP.SETTING.STATUS': '状态: ',
  'SIGN.UP.FORM.STEP.SETTING.GO.TITLE': '确定是否保存修改内容?',
  'SIGN.UP.FORM.STEP.SETTING.GO.DESC':
    '选择不保存，您修改的内容将被删除且不可恢复。',
  'SIGN.UP.FORM.STEP.RELEASE.TITLE': '发布设置',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.1': '激活状态',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.2': '未激活状态',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.DESC.1':
    '此状态表单，玩家填写后表单信息会同步到联系人列表。',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.DESC.2':
    '未激活状态表单，用户填写后表单信息不回同步到联系人列表。',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TITLE.2': '确定激活表单？',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.DESC.2':
    '表单激活后，用户可通过此表单链接填入并更新个人信息数据。',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TITLE.1': '确定取消激活表单？',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.DESC.1':
    '表单取消激活后，用户仍可通过此表单链接填入并提交个人信息，但无法更新系统内个人信息数据。',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.CONFIRM':
    '输入 <b>取消激活</b> 确认调整',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TO.CLOSE': '取消激活',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TO.1': '表单状态更新为激活',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TO.2': '表单状态更新为未激活',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.LINK.TITLE': '分享链接',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.LINK.COPY': '复制表单链接',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.LINK.COPY.SUCCESS': '复制表单链接成功',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.FACEBOOK': '脸书',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.TWWTTER': '推特',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.QRCODE': '扫描二维码',
  'SIGN.UP.FORM.STEP.RELEASE.QRCODE.TITLE': '表单二维码',
  'SIGN.UP.FORM.STEP.RELEASE.QRCODE.DESC': '扫描二维码可填写表单',
  'SIGN.UP.FORM.STEP.SAVE.SENDER.ADDRESS.WARN':
    '请检查二次确认邮件发件地址设置',
  'SIGN.UP.FORM.STEP.SAVE.SENDER.NAME.WARN': '请检查二次确认邮件发件人名称设置',
  'SIGN.UP.FORM.STEP.SAVE.SENDER.DOAMIN.NAME.WARN':
    '请检查 二次确认邮件发件人名称/发件地址设置',
};
